import React, { useState } from 'react';

function MailCompose({ initialData, onClose, onSend }) {
    const [to, setTo] = useState(initialData?.to || '');
    const [subject, setSubject] = useState(initialData?.subject || '');
    const [body, setBody] = useState(initialData?.body || '');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!to.trim()) {
            setError('Укажите получателя');
            return;
        }
        if (!subject.trim()) {
            setError('Укажите тему письма');
            return;
        }
        onSend({
            from: { name: 'Вы', email: 'admin@mas-iot.ru', avatar: 'А' },
            to: to.trim(),
            subject: subject.trim(),
            body: body.trim() || '(пустое сообщение)',
            preview: body.trim().slice(0, 120) || '(пустое сообщение)',
        });
    };

    return (
        <div className="compose-overlay" onClick={onClose}>
            <div className="compose-modal" onClick={(e) => e.stopPropagation()}>
                <header className="compose-header">
                    <h3>Новое письмо</h3>
                    <button className="compose-close" onClick={onClose}>✕</button>
                </header>

                <form onSubmit={handleSubmit} className="compose-form">
                    <div className="compose-field">
                        <label>Кому</label>
                        <input
                            type="text"
                            value={to}
                            onChange={(e) => { setTo(e.target.value); setError(''); }}
                            placeholder="email@example.com"
                            autoFocus
                        />
                    </div>

                    <div className="compose-field">
                        <label>Тема</label>
                        <input
                            type="text"
                            value={subject}
                            onChange={(e) => { setSubject(e.target.value); setError(''); }}
                            placeholder="Тема письма"
                        />
                    </div>

                    <div className="compose-field body-field">
                        <textarea
                            value={body}
                            onChange={(e) => setBody(e.target.value)}
                            placeholder="Напишите сообщение..."
                        />
                    </div>

                    {error && <div className="compose-error">⚠️ {error}</div>}

                    <footer className="compose-footer">
                        <button type="submit" className="compose-send">
                            📤 Отправить
                        </button>
                        <button type="button" className="compose-cancel" onClick={onClose}>
                            Отмена
                        </button>
                    </footer>
                </form>
            </div>
        </div>
    );
}

export default MailCompose;